import { useCallback, useEffect, useState } from "react";
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Container,
  Form,
  Modal,
  Placeholder,
  Row,
  Tab,
  Table,
  Tabs,
} from "react-bootstrap";
import ReactDataGrid from "@inovua/reactdatagrid-community";
import "@inovua/reactdatagrid-enterprise/base.css";
import "@inovua/reactdatagrid-enterprise/theme/default-light.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

import "./enquiry.css";
import { LoadOrdersData } from "./LoadOrdersData";
import { BsArrowLeft } from "react-icons/bs";
import { TiDelete } from "react-icons/ti";
import { Link, Route } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import EnquiryModal from "./EnquiryModal";

function Enquiry() {
  //----- GET CURRENT USER -----//
  const tokenString = sessionStorage.getItem("token");
  const userToken = JSON.parse(tokenString);
  const [show, setShow] = useState(false);

  const [dataSource, setDataSource] = useState([]);
  const UserID = userToken.userId;
  const [searchString, setSearchString] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedOrderLines, setSelectedOrderLines] = useState(null);
  const [selectedOrderTracking, setSelectedOrderTracking] = useState(null);
  const [selectedOrderMovements, setSelectedOrderMovements] = useState(null);
  const [selectedOrderActivity, setSelectedOrderActivity] = useState(null);
  const [selectedOrderShipping, setSelectedOrderShipping] = useState(null);

  // Load orders data on initial render and when search string changes
  useEffect(() => {
    setDataSource(LoadOrdersData(searchString, UserID).data);
  }, [searchString]);

  // Get order lines for selected order
  const getOrderLines = async (orderNo) => {
    const url = `/returnOrderLines/${orderNo}`;
    const response = await fetch(url);
    const data = await response.json();
    setSelectedOrderLines(data);
  };

  // Get order tracking for selected order
  const getOrderTracking = async (orderNo) => {
    const url = `/returnOrderTracking/${orderNo}`;
    const response = await fetch(url);
    const data = await response.json();
    setSelectedOrderTracking(data);
  };

  // Get order activity for selected order
  const getOrderActivity = async (orderNo) => {
    const url = `/returnOrderActivity/${orderNo}`;
    const response = await fetch(url);
    const data = await response.json();
    setSelectedOrderActivity(data);
  };

  // Get order movements for selected order
  const getOrderMovements = async (orderNo) => {
    const url = `/returnOrderMovements/${orderNo}`;
    const response = await fetch(url);
    const data = await response.json();
    setSelectedOrderMovements(data);
  };

  // Get order shipping for selected order
  const getOrderShipping = async (orderNo) => {
    const url = `/returnOrderShipping/${orderNo}`;
    const response = await fetch(url);
    const data = await response.json();
    setSelectedOrderShipping(data);
    console.log("Order Shipping: ", data);
  };

  // WMS Status Descriptions
  const wmsStatusDescriptions = {
    0: "Loaded",
    1: "Work in Progress",
    2: "Work in Progress",
    3: "Complete",
    5: "Exported",
    6: "Error",
    8: "Picked & Ready for Packing",
    9: "Cancelled",
    10: "Hold",
  };

  // WMS Order Types
  const wmsOrderTypes = {
    1: "Sales Order",
  };

  const columns = [
    { name: "OrderNo", header: "OrderNo", type: "string", defaultFlex: 0 },
    {
      name: "Name",
      header: "Name",
      type: "string",
      defaultFlex: 1,
    },
    {
      name: "Lines",
      header: "Lines",
      type: "number",
      defaultFlex: 0,
      textAlign: "end",
      render: ({ value }) => {
        return value;
      },
    },
    {
      name: "Status",
      header: "Status",
      type: "number",
      defaultFlex: 0,
      textAlign: "end",
      render: ({ value }) => {
        // render status as text
        return wmsStatusDescriptions[value];
      },
    },
    {
      name: "Loaded",
      header: "Loaded",
      defaultFlex: 0,
      render({ value }) {
        return moment(value).format("DD/MM/YYYY");
      },
      sort: (a, b) => {
        //console.log("a: ", a, "b: ", b);
        a = moment(a, moment.ISO_8601, true).format();
        b = moment(b, moment.ISO_8601, true).format();

        return new Date(a) - new Date(b);
      },
    },
  ];
  const theme = "default-dark";
  const [selected, setSelected] = useState(null);

  const onSelectionChange = useCallback((selected) => {
    const orderNo = selected.selected;
    setSelected(orderNo); // selected = OrderNo
    setSelectedOrder(selected.data); // data = object of selected row
    getOrderLines(orderNo); // get order lines for selected order no.
    getOrderTracking(orderNo); // get order tracking for selected order no.
    getOrderActivity(orderNo); // get order activity for selected order no.
    getOrderMovements(orderNo); // get order movements for selected order no.
    getOrderShipping(orderNo); // get order shipping for selected order no.
    setShow(true);
  }, []);

  const handleCopyToClipboard = (data) => {
    navigator.clipboard.writeText(data);
  };
  // Context menu for stock grid, to allow copying of data such as product number
  const renderRowContextMenu = useCallback(
    (menuProps, { rowProps, columnProps }) => {
      menuProps.autoDismiss = true;
      menuProps.items = [
        {
          label: "Copy Order Number ",
          onClick: () => handleCopyToClipboard(rowProps.data.OrderNo),
        },
      ];
    },
    []
  );

  const gridStyle = { minHeight: "80vh" };

  return (
    <div className="m-3">
      <>
        {/* <h2>Order Enquiry</h2> */}
        <div className="d-flex align-items-center mb-3">
          <Form.Label className="m-0">Find Order: &nbsp;</Form.Label>
          <div className="text-input">
            <Form.Control
              size="sm"
              type="text"
              placeholder="Search Order Number or Customer Name..."
              value={searchString}
              onChange={(e) => {
                setSearchString(e.target.value);
                setSelected(null);
              }}
            />
          </div>
        </div>
        {/* Main Orders Grid */}
        <ReactDataGrid
          idProperty="OrderNo"
          columns={columns}
          dataSource={dataSource}
          style={gridStyle}
          theme={theme}
          //   onSelectionChange={onSelectionChange}
          //   handle={setGridRef_stock}
          renderRowContextMenu={renderRowContextMenu}
          enableSelection={true}
          onSelectionChange={onSelectionChange}
        />

        {/* Modal for Order Details */}
        <EnquiryModal
          show={show}
          setShow={setShow}
          aria-labelledby="contained-modal-title-vcenter"
          selected={selected}
          selectedOrder={selectedOrder}
          selectedOrderLines={selectedOrderLines}
          selectedOrderTracking={selectedOrderTracking}
          selectedOrderMovements={selectedOrderMovements}
          selectedOrderActivity={selectedOrderActivity}
          wmsStatusDescriptions={wmsStatusDescriptions}
          wmsOrderTypes={wmsOrderTypes}
          selectedOrderShipping={selectedOrderShipping}
        />
      </>
    </div>
  );
}

export default Enquiry;
